import { render } from "./InfosOverlay.vue?vue&type=template&id=aeec1e6e&scoped=true"
import script from "./InfosOverlay.vue?vue&type=script&lang=js"
export * from "./InfosOverlay.vue?vue&type=script&lang=js"

import "./InfosOverlay.vue?vue&type=style&index=0&id=aeec1e6e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-aeec1e6e"

export default script